<template>
	<c-dialog ref="dialog" title="批量派工" height="400" width="500" @resolve="submitHandle">
		<div class="total flex-around-center">
			<div class="item flex-column flex-center">
				<div class="num">{{taskCount}}</div>
				<p>任务数</p>
			</div>
			<div class="item flex-column flex-center">
				<div class="num">{{totalPlanCount}}</div>
				<p>计划数</p>
			</div>
		</div>
		
		<c-form ref="form" vertical unit-width="100%">
			<c-form-item label="分配人员" tip="不选择分配人员，直接点击【确定】， 则清空已分配人员">
				<c-select name="distribute_list" async :multiple="{limit:20,linefeed:true}" @search="searchUser" v-model="distribute_list" ></c-select>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
	export default {
		name: 'taskAllotBatch',

		data() {
			return {
				taskCount: 0,
				totalPlanCount: 0,
                distribute_list: [],
				_taskIds: []
			}
		},
		
		methods: {
			/**
			 * 打开批量分配弹窗
			 * @param {Array} tasks - 勾选的任务列表
			 */
			open(tasks) {
				this._taskIds = tasks.map(item => item.id);
				this.taskCount = tasks.length;
				this.totalPlanCount = tasks.reduce((sum, item) => sum + (parseInt(item.plan_count) || 0), 0);
				this.$refs.form.clear();
				this.$refs.dialog.open();
			},

			/************搜索用户*******************************/
			searchUser(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'SYSUSER',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},
			
			submitHandle(stop, next) {
				stop();

				this.request({
					url: '/task/distribute/batchEdit',
					data: {
						list_filter: {
                            ids: this._taskIds
                        },
                        distribute_list: this.distribute_list.map(item => ({
							user_id: item,
							qty: 0
						}))
					},
					loading: true,
					success: data => {
						let Mtype = 'success';
						let message = '成功分配' + data.success_count + '条任务';
						if(data.fail_count > 0 && data.success_count > 0){
							Mtype = 'warn';
							message = '成功' + data.success_count + '条，失败' + data.fail_count + '条';
						}else if(data.fail_count > 0 && data.success_count == 0){
							Mtype = 'fail';
							message = '失败' + data.fail_count + '条';
						}
						this.$message({
							message: message,
							type: Mtype
						});
						next();
						this.$emit('resolve');
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.total {
		padding: 20px 0;
		margin: 10px 20px 0px;
		background: #F5F5F5;
		
		.item {
			height: 60px;
			
			.num {
				margin-bottom: 10px;
				font-size: 20px;
				font-weight: bold;
				color: var(--color-main);
			}

			p {
				font-size: 13px;
				color: #666;
			}
		}
	}
</style>
